import { isNil } from 'lodash';
import React, { ReactNode, useContext } from 'react';
import { View } from '@shared/components/View';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { MBTextOverlineBold } from '@shared/components/typography';
import { MBMenuRow } from '@shared/scenes/cards/bulk/components/menuRow';
import { ColorThemeContext, grid } from '@shared/styles';
import { getTestId } from '@shared/util/getTestId';

interface Props {
  title: string;
  options: string[];
  selectedOption?: string;
  getLabel(option: string): ReactNode;
  getIcon?(option: string): MBIconV2Name;
  onSelectOption(option: string): void;
  testID?: string;
}
export function MBSingleSelect({
  title,
  getIcon,
  getLabel,
  onSelectOption,
  options,
  selectedOption,
  testID,
}: Props) {
  const colors = useContext(ColorThemeContext);
  return (
    <View testID={testID}>
      <View paddingVertical={2} paddingHorizontal={3}>
        <MBTextOverlineBold color={colors.foregroundInactive}>{title}</MBTextOverlineBold>
      </View>
      {options.map(current => (
        <MBMenuRow
          key={current}
          isHidingPressableIndicator
          onPress={() => onSelectOption(current)}
          title={getLabel(current)}
          image={
            !isNil(getIcon) && (
              <MBIconV2 name={getIcon(current)} size={grid(3)} color={colors.foregroundActive} />
            )
          }
          skipWrappingIcon
          icon={
            selectedOption === current && (
              <MBIconV2 name="check-filled" size={grid(3)} color={colors.accent} />
            )
          }
          testID={getTestId('single-select-option', getLabel(current)?.toString())}
        />
      ))}
      <View padding={1} />
    </View>
  );
}
